import instance from '../../axios/utils.ts/instance';
import { ApiResponse } from '../../../constants/types';
import {
  SITE_TERM_KEY,
  SiteTerm,
} from '../../../constants/types/site-terms-type';

// 메모리 캐시라 새로고침 전까지 갱신되지 않는다 (siteConfigApi 와 동일 정책)
const cache = new Map<SITE_TERM_KEY, Promise<SiteTerm>>();

/**
 * 사이트 약관 조회 (무인증)
 * 같은 키는 한 번만 요청하고, 실패하면 캐시에서 지워 다음 호출 때 재시도한다.
 *
 * @param key 약관 키
 */
export const getSiteTerm = (key: SITE_TERM_KEY): Promise<SiteTerm> => {
  const cached = cache.get(key);
  if (cached) return cached;

  const request = instance
    .get<ApiResponse<SiteTerm>>(`/v1/site-terms/${key}`)
    .then((response) => response.data.data);
  request.catch(() => cache.delete(key));
  cache.set(key, request);
  return request;
};
